import { render, staticRenderFns } from "./DashboardNivelTensaoVisaoMedidoresAmostrais.vue?vue&type=template&id=5c4ab5e3&"
import script from "./DashboardNivelTensaoVisaoMedidoresAmostrais.vue?vue&type=script&lang=js&"
export * from "./DashboardNivelTensaoVisaoMedidoresAmostrais.vue?vue&type=script&lang=js&"
import style0 from "./DashboardNivelTensaoVisaoMedidoresAmostrais.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VDataTable,VIcon,VRow,VSheet,VTooltip})
